import {BatteryTestSchedulerActions, BatteryTestSchedulerActionTypes} from '../actions/battery-test-scheduler.actions';
import {BatteryTestSchedulerModel, BatteryTestSchedulerDetailModel, BatteryTestSchedulerResultModel} from '../battery-test.model';

export interface State {
  isLoading: boolean;
  isLoaded: boolean;
  entities: BatteryTestSchedulerModel[] | null;
}

export const initialState: State = {
  isLoading: false,
  isLoaded: false,
  entities: null
};

export interface BatteryTestSchedulerDetailState {
  isLoading: boolean;
  isLoaded: boolean;
  entities: BatteryTestSchedulerDetailModel| null;
}

export const initialBatteryTestSchedulerDetailState: BatteryTestSchedulerDetailState = {
  isLoading: false,
  isLoaded: false,
  entities: null
};

export interface BatteryTestSchedulerResultState {
  isLoading: boolean;
  isLoaded: boolean;
  entities: BatteryTestSchedulerResultModel[]| null;
}

export const initialBatteryTestSchedulerResultState: BatteryTestSchedulerResultState = {
  isLoading: false,
  isLoaded: false,
  entities: null
};

// export interface BatteryTestSchedulerExecState {
//   isLoading: boolean;
//   isLoaded: boolean;
//   entities: any;
// }

// export const initialBatteryTestSchedulerExecState: BatteryTestSchedulerExecState = {
//   isLoading: false,
//   isLoaded: false,
//   entities: null
// };

export function reducer(state = initialState, action: BatteryTestSchedulerActions): State {
  switch (action.type) {

    case BatteryTestSchedulerActionTypes.LoadBatteryTestScheduler:
      return {...state, isLoading: true, isLoaded: false};
    case BatteryTestSchedulerActionTypes.LoadBatteryTestSchedulerSuccess:
      return {...state, isLoading: false, isLoaded: true, entities: action.payload};
    case BatteryTestSchedulerActionTypes.LoadBatteryTestSchedulerFail:
      return {...state, isLoading: false, isLoaded: true, entities: initialState.entities};

    default:
      return state;
  }
}

export function batteryTestSchedulerDetailReducer(state = initialBatteryTestSchedulerDetailState, action: BatteryTestSchedulerActions): BatteryTestSchedulerDetailState {
  switch (action.type) {

    case BatteryTestSchedulerActionTypes.LoadBatteryTestSchedulerDetail:
      return {...state, isLoading: true, isLoaded: false};
    case BatteryTestSchedulerActionTypes.LoadBatteryTestSchedulerDetailSuccess:
      return {...state, isLoading: false, isLoaded: true, entities: action.payload};
    case BatteryTestSchedulerActionTypes.LoadBatteryTestSchedulerDetailFail:
      return {...state, isLoading: false, isLoaded: true, entities: initialBatteryTestSchedulerDetailState.entities};

    default:
      return state;
  }
}

export function batteryTestSchedulerResultReducer(state = initialBatteryTestSchedulerResultState, action: BatteryTestSchedulerActions): BatteryTestSchedulerResultState {
  switch (action.type) {

    case BatteryTestSchedulerActionTypes.LoadBatteryTestSchedulerResult:
      return {...state, isLoading: true, isLoaded: false};
    case BatteryTestSchedulerActionTypes.LoadBatteryTestSchedulerResultSuccess:
      return {...state, isLoading: false, isLoaded: true, entities: action.payload};
    case BatteryTestSchedulerActionTypes.LoadBatteryTestSchedulerResultFail:
      return {...state, isLoading: false, isLoaded: true, entities: initialBatteryTestSchedulerResultState.entities};

    default:
      return state;
  }
}

// export function batteryTestSchedulerExecReducer(state = initialBatteryTestSchedulerExecState, action: BatteryTestSchedulerActions): BatteryTestSchedulerExecState {
//   switch (action.type) {

//     case BatteryTestSchedulerActionTypes.ExecBatteryTestScheduler:
//       return {...state, isLoading: true, isLoaded: false};
//     // case BatteryTestSchedulerActionTypes.ExecBatteryTestSchedulerSuccess:
//     //   return {...state, isLoading: false, isLoaded: true, entities: action.payload};
//     case BatteryTestSchedulerActionTypes.ExecBatteryTestSchedulerFail:
//       return {...state, isLoading: false, isLoaded: true, entities: initialBatteryTestSchedulerExecState.entities};

//     default:
//       return state;
//   }
// }

export const getBatteryTestSchedulerDetailState = (state: BatteryTestSchedulerDetailState) => state;
export const getBatteryTestSchedulerResultState = (state: BatteryTestSchedulerResultState) => state;
// export const getBatteryTestSchedulerExecState = (state: BatteryTestSchedulerExecState) => state;
